/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AnalyticsBaseService } from '../analytics-base-service';
import { AnalyticsApiConfiguration } from '../analytics-api-configuration';
import { AnalyticsStrictHttpResponse } from '../analytics-strict-http-response';

import { marginControllerDeleteByProject } from '../fn/margins/margin-controller-delete-by-project';
import { MarginControllerDeleteByProject$Params } from '../fn/margins/margin-controller-delete-by-project';
import { marginControllerFindByContract } from '../fn/margins/margin-controller-find-by-contract';
import { MarginControllerFindByContract$Params } from '../fn/margins/margin-controller-find-by-contract';
import { marginControllerFindByProject } from '../fn/margins/margin-controller-find-by-project';
import { MarginControllerFindByProject$Params } from '../fn/margins/margin-controller-find-by-project';
import { marginControllerFindByTenant } from '../fn/margins/margin-controller-find-by-tenant';
import { MarginControllerFindByTenant$Params } from '../fn/margins/margin-controller-find-by-tenant';
import { AnalyticsMarginResponseDto } from '../models/analytics-margin-response-dto';

@Injectable({ providedIn: 'root' })
export class AnalyticsMarginsService extends AnalyticsBaseService {
  constructor(config: AnalyticsApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `marginControllerFindByTenant()` */
  static readonly MarginControllerFindByTenantPath = '/o2-analytics/margins/{tenant}';

  /**
   * Get all margins for a tenant.
   *
   * Returns all margins for a tenant with calculated fields (totalCosts, margin, marginPercentage).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marginControllerFindByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerFindByTenant$Response(params: MarginControllerFindByTenant$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<Array<AnalyticsMarginResponseDto>>> {
    const obs = marginControllerFindByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all margins for a tenant.
   *
   * Returns all margins for a tenant with calculated fields (totalCosts, margin, marginPercentage).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marginControllerFindByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerFindByTenant(params: MarginControllerFindByTenant$Params, context?: HttpContext): Observable<Array<AnalyticsMarginResponseDto>> {
    const resp = this.marginControllerFindByTenant$Response(params, context);
    return resp.pipe(
      map((r: AnalyticsStrictHttpResponse<Array<AnalyticsMarginResponseDto>>): Array<AnalyticsMarginResponseDto> => r.body)
    );
  }

  /** Path part for operation `marginControllerFindByProject()` */
  static readonly MarginControllerFindByProjectPath = '/o2-analytics/margins/{tenant}/project/{projectId}';

  /**
   * Get margin by project ID.
   *
   * Returns margin for a specific project with calculated fields (totalCosts, margin, marginPercentage).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marginControllerFindByProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerFindByProject$Response(params: MarginControllerFindByProject$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>> {
    const obs = marginControllerFindByProject(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get margin by project ID.
   *
   * Returns margin for a specific project with calculated fields (totalCosts, margin, marginPercentage).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marginControllerFindByProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerFindByProject(params: MarginControllerFindByProject$Params, context?: HttpContext): Observable<AnalyticsMarginResponseDto> {
    const resp = this.marginControllerFindByProject$Response(params, context);
    return resp.pipe(
      map((r: AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>): AnalyticsMarginResponseDto => r.body)
    );
  }

  /** Path part for operation `marginControllerDeleteByProject()` */
  static readonly MarginControllerDeleteByProjectPath = '/o2-analytics/margins/{tenant}/project/{projectId}';

  /**
   * Delete margin by project ID.
   *
   * Deletes a margin for a specific project. Only margins with status DELETED can be deleted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marginControllerDeleteByProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerDeleteByProject$Response(params: MarginControllerDeleteByProject$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>> {
    const obs = marginControllerDeleteByProject(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete margin by project ID.
   *
   * Deletes a margin for a specific project. Only margins with status DELETED can be deleted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marginControllerDeleteByProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerDeleteByProject(params: MarginControllerDeleteByProject$Params, context?: HttpContext): Observable<AnalyticsMarginResponseDto> {
    const resp = this.marginControllerDeleteByProject$Response(params, context);
    return resp.pipe(
      map((r: AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>): AnalyticsMarginResponseDto => r.body)
    );
  }

  /** Path part for operation `marginControllerFindByContract()` */
  static readonly MarginControllerFindByContractPath = '/o2-analytics/margins/{tenant}/contract/{contractId}';

  /**
   * Get margin by contract ID.
   *
   * Returns margin for a specific contract with calculated fields (totalCosts, margin, marginPercentage).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `marginControllerFindByContract()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerFindByContract$Response(params: MarginControllerFindByContract$Params, context?: HttpContext): Observable<AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>> {
    const obs = marginControllerFindByContract(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get margin by contract ID.
   *
   * Returns margin for a specific contract with calculated fields (totalCosts, margin, marginPercentage).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `marginControllerFindByContract$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  marginControllerFindByContract(params: MarginControllerFindByContract$Params, context?: HttpContext): Observable<AnalyticsMarginResponseDto> {
    const resp = this.marginControllerFindByContract$Response(params, context);
    return resp.pipe(
      map((r: AnalyticsStrictHttpResponse<AnalyticsMarginResponseDto>): AnalyticsMarginResponseDto => r.body)
    );
  }

}
